import React from "react";
import { toast } from "sonner";
import messages from "../assets/icons/ios/messages.png";
import { notifications } from "../hooks/useNotifications";

// A Liquid Glass notification banner from "Sylvester" in Messages. It's also kept in
// Notification Center's history, as on a Mac.
// The glass itself is on sonner's <li> (see `notification-shell` in App.js): sonner sets
// `will-change: opacity` there, which would stop a nested backdrop-filter from seeing the page.
export const notify = (message) => {
  notifications.add(message);
  return toast.custom(() => (
    <div className="notification">
      <img src={messages} alt="" className="notification-icon" />
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline justify-between gap-3">
          <p className="notification-title">Sylvester</p>
          <p className="notification-time">now</p>
        </div>
        <p className="notification-body">{message}</p>
      </div>
    </div>
  ));
};
